const isStringMinLengthReached = (value, minLength = 6) => (value?.length >= minLength);

export default isStringMinLengthReached;
